<template>
  <div style="width: 100%">
    <v-row align="center" style="max-height: 56px" class="mb-3">
      <v-col cols="auto">
        <div class="title text--secondary text-uppercase">
          {{ $t("management.mentorship.feedback.title") }}
        </div>
      </v-col>
      <v-col class="text-end">
        <v-btn
          v-if="role('admin', 'safetyRepresentative')"
          class="primary"
          @click="add"
        >
          <v-icon dark left>note_add</v-icon>
          {{ $t("management.mentorship.feedback.add") }}
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="mentorshipFeedbacks"
      class="safety-elevation-3 table-striped"
    >
      <template v-slot:[`item.form.nameLocale`]="{ item }">
        <a
          v-if="role('admin', 'safetyRepresentative')"
          @click="edit(item)"
          style="text-decoration: underline;"
          >{{ item.form.nameLocale.value }}</a
        >
        <span v-else>{{ item.form.nameLocale.value }}</span>
      </template>
      <template v-slot:[`item.languages`]="{ item }">
        <v-chip
          small
          v-for="[language] in getLanguages(item.form.nameLocales)"
          :key="language"
        >
          <router-link
            class="text-uppercase "
            :to="{
              name: 'mentorship-feedback',
              params: { id: item.id },
              query: { language: language },
            }"
            target="_blank"
          >
            {{ language }}
          </router-link>
        </v-chip>
      </template>
      <template v-slot:[`item.revisionCreated`]="{ item }"
        >{{ item.revisionCreated | date }}
      </template>
    </v-data-table>
    <mentorship-feedback-edit :feedbackId="editFeedbackId" @done="editDone" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import MentorshipFeedbacksQuery from "@/graphql/queries/MentorshipFeedbacks.gql";

import MentorshipFeedbackEdit from "@/components/management/MentorshipFeedbackEdit.vue";

const tableHeaderClass = "text-uppercase subheading text-truncate";

export default {
  components: { MentorshipFeedbackEdit },
  data() {
    return {
      editFeedbackId: null,
    };
  },
  computed: {
    ...mapGetters(["role"]),

    headers() {
      const h = [
        {
          text: this.$i18n.t("management.mentorship.feedback.column.stage"),
          value: "stage",
          class: tableHeaderClass,
        },
        {
          text: this.$i18n.t("management.mentorship.feedback.column.code"),
          value: "code",
          class: tableHeaderClass,
        },
        {
          text: this.$i18n.t("management.mentorship.feedback.column.name"),
          value: "form.nameLocale",
          class: tableHeaderClass,
        },
        {
          text: this.$i18n.t("management.mentorship.feedback.column.revision"),
          value: "revision",
          class: tableHeaderClass,
        },
        {
          text: this.$i18n.t(
            "management.mentorship.feedback.column.revisionCreated"
          ),
          value: "revisionCreated",
          class: tableHeaderClass,
        },
        {
          text: this.$i18n.t("management.mentorship.feedback.column.languages"),
          value: "languages",
          class: tableHeaderClass,
        },
      ];
      return h;
    },
  },
  methods: {
    add() {
      this.editFeedbackId = "";
    },
    edit(feedback) {
      this.editFeedbackId = feedback.id;
    },
    editDone(isUpdated) {
      this.editFeedbackId = null;
      if (isUpdated) {
        this.$apollo.queries.mentorshipFeedbacks.refetch();
      }
    },
    getLanguages(nameLocales) {
      const map = new Map();
      nameLocales.forEach((l) => {
        if (map.has(l.language)) {
          map.get(l.language).push(l);
        } else {
          map.set(l.language, [l]);
        }
      });
      return map;
    },
  },
  apollo: {
    mentorshipFeedbacks: {
      query: MentorshipFeedbacksQuery,
      variables() {
        return {
          all: false,
        };
      },
    },
  },
};
</script>
